export const saglikHayatPage = () => `
  <section class="page-content service-page">
    <div class="container">
      <div class="service-header">
        <h1 class="page-title">Sağlık ve Hayat Sigortaları</h1>
        <p class="page-subtitle">Siz ve aileniz için kapsamlı sağlık güvencesi ve hayat sigortası çözümleri sunuyoruz.</p>
      </div>

      <div class="service-list">
        <div class="service-item">
          <div class="service-icon">
            <img src="/icons/tamamlayıcı_saglık.png" alt="Tamamlayıcı Sağlık">
          </div>
          <div class="service-info">
            <h3>Tamamlayıcı Sağlık Sigortası</h3>
            <p>SGK kapsamındaki kişiler için özel hastanelerde geçerli, uygun fiyatlı sağlık güvencesi. SGK'nın karşılamadığı fark ücretlerini ve ek tedavi masraflarını karşılar.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M22 12h-4l-3 9L9 3l-3 9H2"></path></svg>
          </div>
          <div class="service-info">
            <h3>Özel Sağlık Sigortası</h3>
            <p>Kapsamlı sağlık güvencesi ile özel hastanelerde ayakta ve yatarak tedavi, check-up, doğum ve ameliyat teminatları. Bireysel ve kurumsal seçenekler mevcuttur.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Hayat Sigortası</h3>
            <p>Sevdiklerinizin geleceğini güvence altına alın. Vefat, maluliyet ve kritik hastalık teminatları ile ailenizin ekonomik geleceğini koruyun. Birikim seçenekleri de mevcuttur.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
          </div>
          <div class="service-info">
            <h3>Ferdi Kaza Sigortası</h3>
            <p>Günlük yaşamda karşılaşılabilecek kaza risklerine karşı koruma sağlar. Kaza sonucu ölüm, sürekli sakatlık ve tedavi masraflarını karşılar.</p>
          </div>
        </div>
      </div>

      <div class="service-cta">
        <h2>Sağlığınız ve Geleceğiniz İçin Teklif Alın</h2>
        <p>Size ve ailenize en uygun sağlık ve hayat sigortası poliçesini birlikte belirleyelim.</p>
        <a href="/teklif-al" class="btn-primary">Hemen Teklif Al</a>
      </div>
    </div>
  </section>
`;
